import { ReactNode } from 'react';
import { To } from 'react-router-dom';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import ButtonBase from '@sorare/core/src/atoms/buttons/ButtonBase';
import { Caption } from '@sorare/core/src/atoms/typography';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Wrapper = styled(ButtonBase)`
  position: relative;
  isolation: isolate;
  padding: var(--double-unit);
  border-radius: var(--double-unit);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: var(--double-unit);
  &:hover,
  &:focus {
    filter: brightness(1.1);
    color: inherit;
  }
  transition: transform 0.1s ease-in-out;

  @media ${tabletAndAbove} {
    aspect-ratio: unset;
    padding: var(--triple-unit);
  }

  &:active {
    transform: scale(0.99);
  }

  &::before {
    content: '';
    inset: 0;
    position: absolute;
    pointer-events: none;
    background: linear-gradient(
      180deg,
      rgba(var(--c-rgb-neutral-100), 0.2) 0%,
      rgba(var(--c-rgb-neutral-100), 0.15) 30%,
      rgba(var(--c-rgb-neutral-100), 0.1) 60%,
      rgba(var(--c-rgb-neutral-100), 0.2) 70%
    );
  }

  & > * {
    z-index: 1;
  }
`;

const Footer = styled(Caption).attrs({ as: 'div' })`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--unit);
  margin-top: auto;
`;

type Props = {
  gridArea: string;
  onClick?: () => void;
  to?: To;
  tag?: ReactNode;
  footer?: ReactNode;
  className?: string;
};
export const PlayPageTile = ({
  gridArea,
  onClick,
  to,
  tag,
  footer,
  className,
}: Props) => {
  return (
    <Wrapper
      className={className}
      style={{ gridArea }}
      as={to ? Link : 'button'}
      onClick={onClick}
      to={to}
    >
      {tag}
      {footer && <Footer>{footer}</Footer>}
    </Wrapper>
  );
};
